import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import ConfigErrorScreen from './components/ConfigErrorScreen'
import { supabaseConfigError } from './lib/supabase'
import { initDarkModeFromStorage } from './theme'
import './index.css'

// Applique la préférence de thème clair/sombre AVANT le premier rendu, pour
// TOUTES les routes (y compris /login et les pages légales). Sans ça, seul le
// dashboard appelait initDarkModeFromStorage() à son montage → la porte d'entrée
// restait en clair au chargement à froid même si l'avocat avait choisi sombre.
initDarkModeFromStorage()

// Init Sentry — guard si DSN absent (dev local sans .env Sentry).
// Conformité RGPD pénale : sendDefaultPii=false + masking total des replays
// (sans masking, le SDK enregistre le texte d'une plainte en cours de
// rédaction). beforeSend retire cookies/Authorization/email/IP avant envoi.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    beforeSend: scrubPii,
  })
}

function scrubPii(event) {
  if (event.request) {
    delete event.request.cookies
    if (event.request.headers) {
      delete event.request.headers.Authorization
      delete event.request.headers.authorization
      delete event.request.headers.Cookie
      delete event.request.headers.cookie
    }
    if (event.request.url) {
      event.request.url = scrubUrlSecrets(event.request.url)
    }
  }
  if (event.user) {
    event.user.email = undefined
    event.user.username = undefined
    event.user.ip_address = undefined
  }
  if (Array.isArray(event.breadcrumbs)) {
    event.breadcrumbs = event.breadcrumbs.map((b) => {
      if (b?.data?.url) b.data.url = scrubUrlSecrets(b.data.url)
      return b
    })
  }
  return event
}

function scrubUrlSecrets(url) {
  if (typeof url !== 'string') return url
  return url.replace(/([?&])(token|api_key|apikey|secret|password|key)=[^&]+/gi, '$1$2=***')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {supabaseConfigError ? <ConfigErrorScreen message={supabaseConfigError} /> : <App />}
  </React.StrictMode>
)
